import { apiGet, apiPatch } from './client';
import type {
  DisclosureLevel3,
  DisclosureLevel3BatchRequest,
} from '../types/DisclosureLevel3';

export function getDisclosureLevel3(): Promise<DisclosureLevel3[]> {
  return apiGet<DisclosureLevel3[]>('/api/disclosure-level-3');
}

export function saveBatchDisclosureLevel3(
  added: DisclosureLevel3[],
  modified: DisclosureLevel3[],
  deletedIds: string[],
): Promise<DisclosureLevel3[]> {
  return apiPatch<DisclosureLevel3BatchRequest, DisclosureLevel3[]>(
    '/api/disclosure-level-3/batch',
    { added, modified, deleted: deletedIds },
  );
}
